/** Site alive time counter */
export function initAliveTime(): void {
  const daysEl = document.querySelector('.alivetime_days')
  const hoursEl = document.querySelector('.alivetime_hours')
  const minutesEl = document.querySelector('.alivetime_minutes')
  const secondsEl = document.querySelector('.alivetime_seconds')

  if (!daysEl || !hoursEl || !minutesEl) return

  const meta = document.querySelector<HTMLMetaElement>('meta[name="alivestart"]')
  if (!meta) return

  const startDate = new Date(meta.content)

  function update() {
    const now = new Date()
    const diff = now.getTime() - startDate.getTime()
    const totalDays = diff / 86400000
    const days = Math.floor(totalDays)
    const totalHours = (totalDays - days) * 24
    const hours = Math.floor(totalHours)
    const totalMinutes = (totalHours - hours) * 60
    const minutes = Math.floor(totalMinutes)
    const seconds = Math.floor((totalMinutes - minutes) * 60)

    daysEl!.textContent = String(days)
    hoursEl!.textContent = String(hours)
    minutesEl!.textContent = String(minutes)
    if (secondsEl) secondsEl.textContent = String(seconds)
  }

  update()
  setInterval(update, 1000)
}
